import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from './HeroSection';
import Footer from './Footer';
import Seo from './Seo';
import './ProjectsShowcasePage.css';

const SHOWCASE_PROJECTS = [
  {
    owner: 'hathach',
    name: 'tinyusb',
    description: 'An open source, cross-platform USB Host/Device stack for embedded systems.'
  },
  {
    owner: 'wolfssl',
    name: 'wolfssl',
    description: 'Small, fast, portable SSL/TLS library for embedded devices and IoT, with TLS 1.3 and DTLS 1.3 support.'
  },
  {
    owner: 'flipperdevices',
    name: 'flipperone-mcu-firmware',
    description: 'MCU firmware for the Flipper One, the portable multi-tool for pentesters and hardware hackers.'
  },
  {
    owner: 'ventZl',
    name: 'cmrx',
    description: 'Memory-protected microkernel real-time operating system for microcontrollers without an MMU.'
  },
  {
    owner: 'supertinykernel-rtos',
    name: 'stk',
    description: 'Lightweight, deterministic bare-metal C++ RTOS for ARM Cortex-M and RISC-V MCUs, with an x86 emulator for development.'
  },
  {
    owner: 'VuqarAhadli',
    name: 'MiniOS-ESP',
    description: 'FreeRTOS-based, Unix-like command-line OS for ESP32 with kernel-level process management and an interactive shell.'
  },
  {
    owner: 'RT-Thread',
    name: 'rt-thread',
    description: 'Open source, community-driven real-time operating system for embedded devices, with a rich middleware ecosystem and support for a wide range of MCUs.'
  },
  {
    owner: 'apache',
    name: 'nuttx',
    description: 'Mature, POSIX-compliant real-time operating system with a small footprint, scalable from 8-bit to 64-bit microcontrollers.'
  },
  {
    owner: 'meshtastic',
    name: 'firmware',
    description: 'Open source, off-grid mesh networking firmware for long-range LoRa radios, running on ESP32, nRF52, RP2040 and STM32 devices.'
  }
];

const ProjectsShowcasePage = () => {
  const navigate = useNavigate();

  const goToDashboard = (owner, name) => {
    navigate(`/public/${owner}/${name}`);
  };

  return (
    <div className="showcase-page">
      <Seo
        title="Projects Showcase – MemBrowse"
        description="Open source firmware and embedded projects using MemBrowse to track memory footprint across builds — including TinyUSB, wolfSSL, CMRX, SuperTinyKernel, MiniOS-ESP, RT-Thread, Apache NuttX, Meshtastic, and the Flipper One firmware."
        path="/showcase"
      />

      <HeroSection
        title="Projects Showcase"
        subtitle="Selected Open source projects using MemBrowse to track memory across builds."
      />

      <section className="showcase-content-section">
        <div className="showcase-section-container">
          <div className="showcase-grid">
            {SHOWCASE_PROJECTS.map((project) => {
              const slug = `${project.owner}/${project.name}`;
              return (
                <div
                  key={slug}
                  className="showcase-card"
                  onClick={() => goToDashboard(project.owner, project.name)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      goToDashboard(project.owner, project.name);
                    }
                  }}
                  role="link"
                  tabIndex={0}
                  aria-label={`Open MemBrowse dashboard for ${slug}`}
                >
                  <div className="showcase-card-header">
                    <a
                      href={`https://github.com/${slug}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="showcase-card-avatar-link"
                      onClick={(e) => e.stopPropagation()}
                      title={`${slug} on GitHub`}
                      aria-label={`${slug} on GitHub`}
                    >
                      <img
                        src={`https://github.com/${project.owner}.png?size=120`}
                        alt=""
                        className="showcase-card-avatar"
                        loading="lazy"
                        onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
                      />
                    </a>
                    <h2 className="showcase-card-title">
                      <span className="showcase-card-owner">{project.owner}</span>
                      <span className="showcase-card-separator">/</span>
                      <span className="showcase-card-name">{project.name}</span>
                    </h2>
                  </div>

                  {project.description && (
                    <p className="showcase-card-description">{project.description}</p>
                  )}

                  <div className="showcase-card-footer">
                    <span className="showcase-card-cta">View dashboard →</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProjectsShowcasePage;
